<template>
  <el-tabs v-model="activeName">
    <el-tab-pane label="修改密码" name="first">
      <div class="addSensor_form">
        <el-form ref="form" :model="form" label-width="120px" class="demo-ruleForm">
          <el-form-item label="*原密码">
            <el-input v-model="form.old_pwd" placeholder="请输入原密码" type="password"></el-input>
          </el-form-item>
          <el-form-item label="*新密码密码">
            <el-input v-model="form.new_pwd" placeholder="请输入新密码" type="password" ></el-input>
          </el-form-item>
          <el-form-item label="*确认新密码">
            <el-input v-model="form.new_pwd_again" placeholder="请再次输入新密码" type="password"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onSubmit">确定修改</el-button>
            <el-button @click="cancel">取消</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-tab-pane>
  </el-tabs>
</template>

<script>
export default {
  data () {
    return {
      activeName: 'first',
      form: {
        old_pwd: '',
        new_pwd: '',
        new_pwd_again: ''
      },
      token: window.sessionStorage.getItem('token'),
      username: window.sessionStorage.getItem('username')
    }
  },
  methods: {
    onSubmit () {
      if (this.form.new_pwd === this.form.new_pwd_again) {
        let chg = {
          'newPassword': this.form.new_pwd,
          'oldPassword': this.form.old_pwd
        }
        this.axios.put(this.$store.state.ip + 'user/user/resetpassword', chg,
          {
            headers: {'Authorization': 'Bearer ' + window.sessionStorage.getItem('token')}
          }).then(res => {
          if (res.msg === 'SUCCESS') {
            this.$message.success('修改成功')
          }
          window.sessionStorage.setItem('token', '')
          window.sessionStorage.setItem('username', '')
          this.$router.push('/')
        }).catch(err => {
          console.log(err)
        })
      } else {
        this.$message.error('输入的两次新密码不一致')
      }
    },
    cancel () {
      this.form = {}
    }
  }
}
</script>

<style scoped>
  .addSensor_form {
    width: 450px;
    margin-left: 20px;
    margin-top: 30px;
  }
</style>



// WEBPACK FOOTER //
// src/components/setting/chgPassword.vue